//LIBRARIES
import React, { Fragment } from 'react';
import { reduxForm } from 'redux-form';
import { MuiThemeProvider } from '@material-ui/core/styles';

//COMPONENTS
import PersonalDetails from '../PersonalDetails';
import EmergencyContacts from 'components/landlord_app/applications/ManualApplicantDrawer/EmergencyContacts';
import Pets from 'components/landlord_app/applications/ManualApplicantDrawer/Pets';
import Vehicles from 'components/landlord_app/applications/ManualApplicantDrawer/Vehicles';
import OtherOccupants from 'components/landlord_app/applications/ManualApplicantDrawer/OtherOccupants';
import Header from 'components/shared/Header';
import { ExistingLeadError } from 'components/shared/DuplicateLead/DuplicateLead';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

//HELPERS
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { muiThemeNext } from 'helpers/MUIFiles';
import { AccentColor } from 'helpers/AccentColorHelper';

let addApplicantForm = props => {
  const {
    handleSubmit,
    applicantType,
    hideSalary,
    collectLeadSinNumberDuringApplication,
    minimumApplicantAge,
  } = props;

  const headerVerbiage =
    applicantType === 'tenant' ? (
      <span>{getTranslatedString('landlordPortal.addApplicantForm.residentDetails')}</span>
    ) : (
      getTranslatedString('landlordPortal.addApplicantForm.applicantDetails')
    );
  return (
    <MuiThemeProvider theme={muiThemeNext(AccentColor())}>
      <form onSubmit={handleSubmit}>
        <div className="row" style={{ marginBottom: '10px' }}>
          <Header name={headerVerbiage} />
        </div>

        <PersonalDetails
          disableBirthdayAndSalary
          hideSIN
          hideSalary={hideSalary}
          collectLeadSinNumberDuringApplication={collectLeadSinNumberDuringApplication}
          minimumApplicantAge={minimumApplicantAge}
        />
        <ExistingLeadError
          existingTenant={props.existingTenant}
          toggleConfirmationDialog={props.toggleConfirmationDialog}
        />
        {renderApplicationDetails(props)}
      </form>
    </MuiThemeProvider>
  );
};

addApplicantForm = reduxForm({
  form: 'add_applicant_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(addApplicantForm);

const renderApplicationDetails = props => {
  if (props.hideApplicationDetails && !props.overrideHideApplicationDetails) return;

  if (hostIsCapreit()) {
    return (
      <RenderIfToggleOn toggle="ui.emergency_contacts">
        <div style={{ marginBottom: '25px' }}>
          <EmergencyContacts {...props} />
        </div>
      </RenderIfToggleOn>
    );
  }

  const showTenantAdditionalOccupant = props.showTenantAdditionalOccupant && !hostIsBoardwalk();
  const showTenantPetDetails = props.showTenantPetDetails && !hostIsBoardwalk();
  const showVehicle = !hostIsBoardwalk();
  return (
    <Fragment>
      <RenderIfToggleOn toggle="ui.emergency_contacts">
        <div style={{ marginBottom: '25px' }}>
          <EmergencyContacts {...props} newMUI />
        </div>
      </RenderIfToggleOn>

      {showTenantAdditionalOccupant && (
        <div style={{ marginBottom: '15px' }}>
          <OtherOccupants {...props} />
        </div>
      )}

      {showTenantPetDetails && (
        <div style={{ marginBottom: '15px' }}>
          <Pets {...props} />
        </div>
      )}
      {showVehicle && (
        <div style={{ marginBottom: '15px' }}>
          <Vehicles {...props} />
        </div>
      )}
    </Fragment>
  );
};

export default addApplicantForm;
